import { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { FingerprintProvider } from './FingerprintProvider';

/**
 * Non-admin wrapper that mounts the Fingerprint provider for fraud detection.
 *
 * Analytics loading used to live here (hand-injected GTM-N6GQ5JQD + GA4 gtag)
 * but those are now owned by:
 *   - Rudderstack JS SDK (client/src/lib/rudderstack.ts) — product analytics,
 *     fans out to GA4 + PostHog + hub webhook.
 *   - GTM container GTM-WR9CBTF (loaded server-side or via marketing site
 *     cross-domain) — session replay / popup tools (heap, Clarity, optimonk).
 *
 * The hand-injected GA4 gtag was causing triple-counted sessions alongside
 * Rudderstack's GA4 cloud-mode destination and the GTM GA4 Config tag.
 */
export function ConditionalAnalytics({ children }: { children?: ReactNode }) {
  const [location] = useLocation();
  const isAdminPage = location.startsWith('/admin');
  const shouldWrapFingerprint = !isAdminPage;

  if (shouldWrapFingerprint && children) {
    return <FingerprintProvider>{children}</FingerprintProvider>;
  }

  return <>{children}</>;
}
